import { gql } from "@apollo/client";

import TopicNodeFragment from "@apps/meeting-new/graphql/topic-node-fragment";

export default gql`
  ${TopicNodeFragment}
  query getTopic($topicId: Int!) {
    topic(topicId: $topicId) {
      ...TopicNodeNewPageFragment
      meeting {
        id
        topics {
          edges {
            node {
              id
            }
          }
        }
        agendaTopics {
          id
          isPinned
          carryForward
          canChangePin
          canUpdate {
            permission
          }
          editorDocumentName
          editorWebsocketToken
          topic {
            id
          }
        }
      }
    }
  }
`;
